import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule } from './app.routes'

import { AppComponent }  from './app.component';
import { HeaderComponent } from './header/header.component'
import { SelectorGadgetComponent} from './selector/selector-gadget.component'
import { FooterComponent } from './footer/footer.component'
import { HtmlContainerComponent } from './http_container/html-container.component'
import { HomeComponent } from './home/home.component'

import { NavigatorComponent } from './navigator/navigator.component'
import { StateDirective } from './navigator/state.directive'
import { SelectorListComponent} from './selector/list/list.component'
import { HttpClientModule } from '@angular/common/http';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { JsonPipe } from '@angular/common';
import { PreviewComponent } from './preview/preview.component'
import { JSONXMLPreviewComponent } from './preview/JSONXMLPreview/JSONXMLPreview.component'
import { CSVPreviewComponent } from './preview/CSVPreview/CSVPreview.component'
import { ProjectComponent } from './selector/project/project.component'
import { SelectorListItemComponent } from './selector/list/selectorlistitem/selector-list-item.component'
import { InplaceEditComponent} from './components/inplace-edit/inplace-edit.component'
import { AlertComponent } from './alert/alert.component'
import { ResultInfoComponent } from './selector/result_info/result-info.component'
import { BusyIndicatorComponent } from './components/busy-indicator/busy-indicator.component'

@NgModule({
  imports: [ BrowserModule, FormsModule, AppRoutingModule, HttpClientModule,
             ReactiveFormsModule, PrettyJsonModule, BrowserAnimationsModule],
  declarations: [ AppComponent, HtmlContainerComponent,
  					SelectorGadgetComponent, NavigatorComponent,
  					SelectorListComponent,
            PreviewComponent, JSONXMLPreviewComponent, CSVPreviewComponent,
            HeaderComponent, FooterComponent, ProjectComponent,
            SelectorListItemComponent, StateDirective, InplaceEditComponent, HomeComponent,
            AlertComponent, ResultInfoComponent, BusyIndicatorComponent],
  providers: [
            /* { provide: JsonPipe, useClass: SafeJsonPipe } */
    ],
  bootstrap: [ AppComponent]
})
export class AppModule { }
